var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46858 7.86963C7.10793 7.86963 6.81641 8.10285 6.81641 8.39137V12.5653C6.81641 12.8538 7.10793 13.087 7.46858 13.087C7.82923 13.087 8.12075 12.8538 8.12075 12.5653V8.39137C8.12075 8.10285 7.82923 7.86963 7.46858 7.86963Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7264 7.86963C10.3657 7.86963 10.0742 8.10285 10.0742 8.39137V12.5653C10.0742 12.8538 10.3657 13.087 10.7264 13.087C11.087 13.087 11.3786 12.8538 11.3786 12.5653V8.39137C11.3786 8.10285 11.087 7.86963 10.7264 7.86963Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8098 2H7.38587C6.75644 2 6.24457 2.5175 6.24457 3.15385V4.30769H4.53261H2.82065C2.50508 4.30769 2.25 4.56558 2.25 4.88462C2.25 5.20365 2.50508 5.46154 2.82065 5.46154H3.96196V15.2692C3.96196 16.2235 4.73005 17 5.67391 17H12.5217C13.4656 17 14.2337 16.2235 14.2337 15.2692V5.46154H15.375C15.6906 5.46154 15.9457 5.20365 15.9457 4.88462C15.9457 4.56558 15.6906 4.30769 15.375 4.30769H13.663H11.9511V3.15385C11.9511 2.5175 11.4392 2 10.8098 2ZM13.0924 15.2692C13.0924 15.5877 12.8367 15.8462 12.5217 15.8462H5.67391C5.35891 15.8462 5.10326 15.5877 5.10326 15.2692V5.46154H13.0924V15.2692ZM7.38587 4.30769V3.15385H10.8098V4.30769H7.38587Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.51a3f9333fa7975b666f7cb376a6419d.svg";
export { ForwardRef as ReactComponent };